import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cms-does-user-shure-to-un-hold-dialog',
  templateUrl: './does-user-shure-to-un-hold-dialog.component.html',
  styleUrls: ['./does-user-shure-to-un-hold-dialog.component.scss']
})
export class DoesUserShureToUnHoldDialogComponent {
  constructor(private dialogRef: MatDialogRef<DoesUserShureToUnHoldDialogComponent>) {}
  unhold(): void {
    this.dialogRef.close(true);
  }
}
